// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file sales/daily_sales.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";

/**
 * @generated from message com.neulink.pharmacy.DailySalesRequest
 */
export class DailySalesRequest extends Message<DailySalesRequest> {
  /**
   * @generated from field: string date = 1;
   */
  date = "";

  constructor(data?: PartialMessage<DailySalesRequest>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DailySalesRequest";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "date", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DailySalesRequest {
    return new DailySalesRequest().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DailySalesRequest {
    return new DailySalesRequest().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DailySalesRequest {
    return new DailySalesRequest().fromJsonString(jsonString, options);
  }

  static equals(a: DailySalesRequest | PlainMessage<DailySalesRequest> | undefined, b: DailySalesRequest | PlainMessage<DailySalesRequest> | undefined): boolean {
    return proto3.util.equals(DailySalesRequest, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.DailySalesResponse
 */
export class DailySalesResponse extends Message<DailySalesResponse> {
  /**
   * @generated from field: float total_sales_amount = 1;
   */
  totalSalesAmount = 0;

  /**
   * @generated from field: float gross_sales_amount = 2;
   */
  grossSalesAmount = 0;

  /**
   * @generated from field: float total_discount = 3;
   */
  totalDiscount = 0;

  /**
   * @generated from field: float total_vat = 4;
   */
  totalVat = 0;

  /**
   * @generated from field: float cash_total = 5;
   */
  cashTotal = 0;

  /**
   * @generated from field: float card_total = 6;
   */
  cardTotal = 0;

  /**
   * @generated from field: float insurance_total = 7;
   */
  insuranceTotal = 0;

  constructor(data?: PartialMessage<DailySalesResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.DailySalesResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "total_sales_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 2, name: "gross_sales_amount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 3, name: "total_discount", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "total_vat", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "cash_total", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "card_total", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 7, name: "insurance_total", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DailySalesResponse {
    return new DailySalesResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DailySalesResponse {
    return new DailySalesResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DailySalesResponse {
    return new DailySalesResponse().fromJsonString(jsonString, options);
  }

  static equals(a: DailySalesResponse | PlainMessage<DailySalesResponse> | undefined, b: DailySalesResponse | PlainMessage<DailySalesResponse> | undefined): boolean {
    return proto3.util.equals(DailySalesResponse, a, b);
  }
}

